import React from 'react';

export const SC = () => {
	return (
		<svg
			width='20'
			height='15'
			viewBox='0 0 20 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_11534_5925)'>
				<mask
					id='mask0_11534_5925'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='20'
					height='15'
				>
					<rect width='20' height='15' fill='white' />
				</mask>
				<g mask='url(#mask0_11534_5925)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0V15H20V0H0Z'
						fill='#2E42A5'
					/>
					<mask
						id='mask1_11534_5925'
						style={{ maskType: 'luminance' }}
						maskUnits='userSpaceOnUse'
						x='0'
						y='0'
						width='20'
						height='15'
					>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 0V15H20V0H0Z'
							fill='white'
						/>
					</mask>
					<g mask='url(#mask1_11534_5925)'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 14.9978L10.0944 -1.25H20.1888L0 14.9978Z'
							fill='#FFD018'
						/>
						<path
							d='M0 14.9979L21.5395 6.87393V-3.18958L0 14.9979Z'
							fill='#E31D1C'
						/>
						<path
							d='M0 14.9979L21.5395 11.8739V6.81042L0 14.9979Z'
							fill='#F7FCFF'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 14.9979H21.5395V10.5604L0 14.9979Z'
							fill='#5EAA22'
						/>
					</g>
				</g>
			</g>
			<rect
				x='0.5'
				y='0.5'
				width='19'
				height='14'
				rx='1'
				stroke='black'
				strokeOpacity='0.1'
			/>
			<defs>
				<clipPath id='clip0_11534_5925'>
					<rect width='20' height='15' rx='1.5' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
